import { MessageSquare, ClipboardList, CalendarClock, Star } from "lucide-react";
import { toast } from "sonner";
import { useCatalogue } from "@/context/CatalogueContext";
import { errorMessage } from "@/lib/api";
import { cn } from "@/lib/utils";

const SHAPES = {
  chatbot: { icon: MessageSquare, label: "Chat" },
  form: { icon: ClipboardList, label: "Form" },
  scheduled: { icon: CalendarClock, label: "Scheduled" },
};

export const ShapeIcons = ({ shapes, withLabels = false }) => (
  <span className="inline-flex items-center gap-2 text-muted-foreground">
    {shapes.filter((s) => SHAPES[s]).map((s) => {
      const { icon: Icon, label } = SHAPES[s];
      return (
        <span key={s} className="inline-flex items-center gap-1 text-xs" title={label}>
          <Icon className="!h-4 !w-4" aria-hidden="true" />
          <span className={withLabels ? "" : "sr-only"}>{label}</span>
        </span>
      );
    })}
  </span>
);

export const FavouriteStar = ({ targetId, name }) => {
  const { favourites, toggleFavourite } = useCatalogue();
  const on = favourites.includes(targetId);
  const click = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const now = await toggleFavourite(targetId);
      toast.success(now ? `${name} added to favourites` : `${name} removed from favourites`);
    } catch (err) {
      toast.error(errorMessage(err));
    }
  };
  return (
    <button type="button" onClick={click} aria-pressed={on} aria-label={on ? `Remove ${name} from favourites` : `Add ${name} to favourites`}
      className="grid h-8 w-8 place-items-center rounded-lg transition-quick hover:bg-muted" data-testid={`favourite-star-${targetId}`}>
      <Star className={cn("!h-[18px] !w-[18px]", on ? "fill-action text-action" : "text-muted-foreground")} aria-hidden="true" />
    </button>
  );
};
